import classNames from "classnames";
import type * as React from "react";

import styles from "./Timeline.module.css";

export interface TimelineMessageProps {
  /** A lucide icon, drawn in a tile above the title. */
  icon: React.ReactNode;
  /** What happened, in a few words ("No sessions yet"); the frame's heading line. */
  title: string;
  /** `danger` tints the tile red and announces the title as an alert. @default "neutral" */
  tone?: "neutral" | "danger";
  /** A button that resolves the state (Retry, New session, Clear filters). */
  action?: React.ReactNode;
  /** A line under the title that explains it; left out when the title says enough. */
  description?: React.ReactNode;
}

/**
 * A message that takes the whole timeline's place, framed like it and at
 * the loading skeleton's height so the page does not jump between them: the
 * history failed to load, or holds nothing to draw (the `empty` slot).
 */
export function TimelineMessage({
  icon,
  title,
  description,
  tone = "neutral",
  action,
}: TimelineMessageProps) {
  return (
    <div className={classNames(styles.timeline, styles.timelineMessage)}>
      <div className={styles.messageIcon} data-tone={tone}>
        {icon}
      </div>
      <div className={styles.messageText}>
        <p
          className={styles.messageTitle}
          role={tone === "danger" ? "alert" : undefined}
        >
          {title}
        </p>
        {description && (
          <p className={styles.messageDescription}>{description}</p>
        )}
      </div>
      {action}
    </div>
  );
}
